module.exports = __webpack_public_path__ + "static/neighbors-having-coffee-desktop.00d372e1.webp";